import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@app/api/api-services/auth.service';
import { Subscription } from 'rxjs';
import { CustomUtils } from 'src/app/shared/utils/custom-utils';
import { SidebarMenuItem } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-item.model';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { iconColors } from '@app/shared/constants';

@Component({
  selector: 'sidebar-program-selector',
  templateUrl: './sidebar-program-selector.component.html',
  styleUrls: ['./sidebar-program-selector.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidebarProgramSelectorComponent implements OnInit, OnDestroy {
  @Input()
  public programs = new Array<SidebarMenuItem>();

  @Input()
  isCollapsed: boolean;

  public changeInProgress = false;
  public expanded = false;
  public iconColors = iconColors;

  public get currentProgramName(): string {
    return this.tokenStorage.userInfo.CurrentProgramName;
  }

  public get currentProgramType(): string {
    const type = this.tokenStorage.userInfo.CurrentProgram?.Type;
    return type ? CustomUtils.getProgramType(type) : '';
  }

  private readonly subscriptions = new Array<Subscription>();

  constructor(private readonly tokenStorage: TokenStorageService, private readonly authService: AuthService) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.authService.programChange.subscribe(
        () => (this.changeInProgress = false),
        () => (this.changeInProgress = false)
      )
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }

  public onOutsideClick(): void {
    this.expanded = false;
  }

  public toggleExpand(e: MouseEvent): void {
    e.stopPropagation();

    if (this.changeInProgress) {
      return;
    }

    this.expanded = !this.expanded;
  }

  public changeProgram(e: MouseEvent, program: SidebarMenuItem): void {
    e.stopPropagation();
    this.changeInProgress = true;
    this.expanded = false;
    program.action();
  }
}
